import React from "react";
import { Wrap } from "./style";
import img from "../../../../assets/imgs/img.png";
export default function MyProfile() {
  return (
    <Wrap>
      <Wrap.Title>
        <h1>My ProFile</h1>
        <span> Read to jump back in?</span>
      </Wrap.Title>
      <Wrap.Body>
        <Wrap.Content>
          <Wrap.Contact>
            <Wrap.ContentTitle>Contact Information</Wrap.ContentTitle>
            <Wrap.Items>
              <Wrap.Input placeholder="First Name" />
              <Wrap.Input mr="true" placeholder="Last Name" />
            </Wrap.Items>
            <Wrap.Items>
              <Wrap.Input placeholder="Email" />
              <Wrap.Input mr="true" placeholder="Phone" />
            </Wrap.Items>
            <Wrap.Items>
              <Wrap.Input placeholder="Mobile" />
              <Wrap.Input mr="true" placeholder="Skype" />
            </Wrap.Items>
            <Wrap.ContentTitle>Social Media</Wrap.ContentTitle>
            <Wrap.Items>
              <Wrap.Input placeholder="Facebook Url" />
              <Wrap.Input mr="true" placeholder="Twitter Url" />
            </Wrap.Items>
            <Wrap.Items>
              <Wrap.Input placeholder="Linkedin Url" />
              <Wrap.Input mr="true" placeholder="Instagram Url" />
            </Wrap.Items>
            <Wrap.TextArea rows="8" placeholder="About me" />
            <Wrap.Button>UPDATE PROFILE</Wrap.Button>
          </Wrap.Contact>
          <Wrap.ChangePassword>
            <Wrap.ContentTitle>Change Password</Wrap.ContentTitle>
            <Wrap.Items>
              <Wrap.Input placeholder="Old Password" />
            </Wrap.Items>
            <Wrap.Items>
              <Wrap.Input placeholder="New Password" />
              <Wrap.Input mr="true" placeholder="Confirm New Password" />
            </Wrap.Items>
            <Wrap.Button>CHANGE PASSWORD</Wrap.Button>
          </Wrap.ChangePassword>
        </Wrap.Content>
        <Wrap.Img>
          <h2>Photo</h2>
          <img src={img} alt="img" />
          <Wrap.Upload> UPLOAD PROFILE PHOTO</Wrap.Upload>
        </Wrap.Img>
      </Wrap.Body>
    </Wrap>
  );
}
